import { render, staticRenderFns } from "./permissions-list.vue?vue&type=template&id=0cc6082e&"
import script from "./permissions-list.vue?vue&type=script&lang=js&"
export * from "./permissions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports